import React, { lazy, Suspense } from "react";

import RouteLoadingIndicator from "../../components/RouteLoadingIndicator/RouteLoadingIndicator";


const LazyContainer = lazy(() => import("./CreditHistory.container") as Promise<{ default: React.ComponentType<any>; }>);

interface ContainerProps {
  [key: string]: any;
}

const Container: React.FC<ContainerProps> = (props) =>
  <Suspense fallback={<RouteLoadingIndicator />}>
    <LazyContainer {...props} />
  </Suspense>;

export default Container;
